export default __webpack_public_path__ + "static/media/user-check.f29819a9.svg";